let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("azUNk")).then(() => parcelRequire('eyQ7o'));